import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InternationalTradeRussiaEconRev = _resolveComponent("InternationalTradeRussiaEconRev")!
  const _component_InvestmentsRussiaEconRev = _resolveComponent("InvestmentsRussiaEconRev")!
  const _component_RussiaLimitations = _resolveComponent("RussiaLimitations")!
  const _component_EconRevTemplate = _resolveComponent("EconRevTemplate")!

  return (_openBlock(), _createBlock(_component_EconRevTemplate, null, {
    default: _withCtx(() => [
      _createVNode(_component_InternationalTradeRussiaEconRev, {
        notForTecRussiaTab: "",
        countryId: $props.countryId,
        onYearChanged: $options.onYearChanged
      }, null, 8, ["countryId", "onYearChanged"]),
      _createVNode(_component_InvestmentsRussiaEconRev, {
        countryId: $props.countryId,
        year: $data.year,
        notForTecRussiaTab: ""
      }, null, 8, ["countryId", "year"]),
      _createVNode(_component_RussiaLimitations, { unfriendlyCountryInfo: $props.unfriendlyCountryInfo }, null, 8, ["unfriendlyCountryInfo"])
    ]),
    _: 1
  }))
}